export default {
  buttonArrowImage: '/images/common/button-arrow.png',
};
